import Vue from 'vue'
import Router from 'vue-router'
import store from './modules/usuario'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Usuario from './views/Usuario.vue'
import Grupos from './views/Grupos.vue'
import Coches from './views/Coches.vue'
import Clientes from './views/Clientes.vue'
import PruebaTesting from './components/PruebaTesting.vue'
import Tareas from './views/Tareas.vue'
import Reservas from './views/Reservas.vue'
import Extras from './views/Extras.vue'
import Tarifas from './views/Tarifas.vue'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        administrador: true,
        vendedor: true
      }
    },
    {
      path: '/testing',
      name: 'testing',
      component: PruebaTesting,
      meta: {
        libre: true
      }
    },
    {
      path: '/tareas',
      name: 'tareas',
      component: Tareas,
      meta: {
        administrador: true,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        libre: true
      }
    },
    {
      path: '/grupos',
      name: 'grupos',
      component: Grupos,
      meta: {
        administrador: true,
        vendedor: true
      }
    },
    {
      path: '/coches',
      name: 'coches',
      component: Coches,
      meta: {
        administrador: true,
        vendedor: true
      }
    },
    {
      path: '/tarifas',
      name: 'tarifas',
      component: Tarifas,
      meta: {
        administrador: true,
        vendedor: true
      }
    },
    {
      path: '/extras',
      name: 'extras',
      component: Extras,
      meta: {
        administrador: true,
      }
    },
    {
      path: '/usuario',
      name: 'usuario',
      component: Usuario,
      meta: {
        administrador: true
      }
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: Clientes,
      meta: {
        administrador: true
      }
    },
    {
      path: '/reservas',
      name: 'reservas',
      component: Reservas,
      meta: {
        administrador: true
      }
    },
  ]
})
router.beforeEach((to, from, next) => {
  
  if(to.matched.some(record => record.meta.libre)){
    next();
  } else if (store.state.usuario && store.state.usuario.rol == 'Administrador'){
    if (to.matched.some(record => record.meta.administrador)){
      next();
    }
  } else if (store.state.usuario && store.state.usuario.rol == 'Vendedor'){
    if (to.matched.some(record => record.meta.vendedor)){
      next();
    }
  } else if (store.state.usuario && store.state.usuario.rol == 'Almacenero'){
    if (to.matched.some(record => record.meta.almacenero)){
      next()
    }
  }else {
    next({path:'/login'});
  }
  
})
export default router
